import Axios from "axios";
import { SET_WEEKEND_LIST, UNSET_WEEKEND_LIST } from "@/store/mutation-types";
import { saveUpdateWeekend, getWeekendList } from "@/store/api";
// initial state
const state = {
    getWeekendList: [],
};

const getters = {
    getWeekendList(state) {
        return state.getWeekendList;
    },
};

const mutations = {
    [SET_WEEKEND_LIST](state, data) {
        state.getWeekendList = data;
    },
    [UNSET_WEEKEND_LIST](state) {
        state.getWeekendList = [];
    },
};

const actions = {
    saveUpdateWeekend({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateWeekend, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getWeekendList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getWeekendList, data)
                .then(function (response) {
                    console.log(response)
                    commit("SET_WEEKEND_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_WEEKEND_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
